import { faFloppyDisk, faPlus } from "@fortawesome/pro-regular-svg-icons";
import { useIsMutating } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { UserRole } from "../../../../../actions/Tenants/config/constantsTyped";
import { RootState } from "../../../../../reducers";
import useAuthorization from "../../../../../utils/authorization";
import { Button } from "../../../../Helper/Button";
import { useQcEntities } from "../../QcEntityContext";
import InvalidCheckModal from "../Summary/InvalidCheckModal";

export function AdvanceRipeningNavButtons({ addFruit, onTriggerBusinessRules }) {
    const user = useSelector((state: RootState) => state.auth.user);
    const auth = useAuthorization();
    const { check } = useQcEntities();
    const isUpdating = useIsMutating() > 0;

    return (
        <div className="py-4 my-1 d-flex justify-content-between align-items-center gap-2">
            <div className="d-inline-flex d-md-block">
                {(user.is_admin || auth.userHasRole(UserRole.TENANT_ADMIN)) && <InvalidCheckModal />}
            </div>

            <div className="d-inline-flex d-md-flex gap-2">
                <Button
                    color={check.do_quality_check !== "yes" ? "secondary" : "primary"}
                    outline
                    disabled={isUpdating || check.do_quality_check !== "yes"}
                    onClick={addFruit}
                    icon={faPlus}
                >
                    Add Fruit
                </Button>

                <Button
                    color={!isUpdating && !!onTriggerBusinessRules ? "primary" : "secondary"}
                    disabled={isUpdating || !onTriggerBusinessRules}
                    onClick={onTriggerBusinessRules}
                    icon={faFloppyDisk}
                >
                    Save check
                </Button>
            </div>

        </div>
    );
}
